{
    "introduction": {
        "title": "Hola, soy Cephable.",
        "back": "Volver a la introducción",
        "description": "Soy tu IA personal para ayudarte a controlar, crear y automatizar las herramientas que ya te encantan, en todas tus conexiones. Hay algunas cosas que debes saber sobre mí.",
        "action": "¡Comencemos!",
        "recording": {
            "title": "Su voz y vídeo permanecen locales.",
            "description": "Nunca grabo, transmito ni envío tu audio o video a la nube. Todas las entradas se procesan en el dispositivo de forma privada y segura."
        },
        "data": {
            "title": "Tus datos son tuyos.",
            "description": "No uso tus comandos ni tu actividad para entrenar modelos para otros. Todo se mantiene privado y los controles de tu aplicación se mueven contigo entre conexiones."
        },
        "offline": {
            "title": "Trabajo cuando otras herramientas no lo hacen.",
            "description": "Las tareas inteligentes, como generar contenido, reescribir, traducir y dictar, se ejecutan localmente. No se requiere la nube. Esto significa que trabajo incluso sin conexión, y tus datos no salen de tu dispositivo."
        },
        "empower": {
            "title": "Creado para empoderar, no para explotar.",
            "description": "Estoy diseñado para mejorar tu control, no para monitorearlo. Sin rastreo invasivo. Sin recopilación de datos intrusivos. Solo información que te funcione."
        }
    },
    "my-capabilities": {
        "title": "¡Perfecto! Así es como puedo ayudarte.",
        "back": "Volver a las capacidades",
        "actionTitle": "Mírame en acción",
        "description": "Aquí están las características y capacidades más relevantes para tu flujo de trabajo, organizadas en torno a las tres cosas que hace Cephable.",
        "action": {
            "title": "Mírame en acción",
            "description": "Explora algunos ejemplos de cómo puedo ayudarte en tus tareas diarias."
        },
        "basedOnInterests": "Según tus intereses",
        "cta": {
            "eyebrow": "Listo cuando estés",
            "title": "Compruébelo en sus aplicaciones."
        }
    },
    "see-me": {
        "title": "¿Quieres ver cómo he ayudado a otros como tú?",
        "back": "Volver a los casos de uso",
        "description": "Vea algunos ejemplos reales de cómo he transformado los flujos de trabajo en diferentes industrias y roles."
    },
    "complete": {
        "title": "¿Estás listo para comenzar a usarme?",
        "description": "¡Ya viste lo que puedo hacer! Ahora, vamos a configurarlo y a empezar a transformar tu flujo de trabajo. Estaré aquí para ayudarte en cada paso del proceso.",
        "action": "Complete la configuración y comience a usar Cephable"
    },
    "apps": {
        "title": "Apoyo las herramientas que ya amas",
        "description": "Con soporte preconfigurado para más de 200 aplicaciones, trabajo con el software que usas a diario. No requiere configuración.",
        "note": "¿No encuentras una aplicación que uses? No hay problema: puedo generar controles o ayudarte a crear flujos de trabajo personalizados que se adapten a tus necesidades.",
        "andMore": "Y más",
        "eyebrow": "Más de 200 aplicaciones, sin necesidad de configuración."
    },
    "actions": {
        "ctaTry": "Pruébalo ahora",
        "ctaWatch": "Ver demostración",
        "apps": "Soy compatible con:",
        "abilities": "Mis habilidades utilizadas:"
    },
    "interests": {
        "title": "¿En qué puedo ayudarte?",
        "back": "Volver a los intereses",
        "description": "Puedo controlar aplicaciones en tu escritorio y dispositivos conectados. Personalicemos tu experiencia: ¿qué te interesa más?",
        "note": "Seleccione todas las que correspondan y le mostraré las características y ejemplos más relevantes para su flujo de trabajo.",
        "action": "Continuar con {{count}} intereses",
        "empty": "Seleccione al menos un interés.",
        "create_design": {
            "label": "Crear y diseñar",
            "shortLabel": "Diseño",
            "description": "Para artistas, comercializadores y creadores de contenido."
        },
        "analyze_report": {
            "label": "Analizar e informar",
            "shortLabel": "Analizar",
            "description": "Para analistas, investigadores y profesionales de negocios."
        },
        "communicate_collaborate": {
            "label": "Comunicarse y colaborar",
            "shortLabel": "Comunicar",
            "description": "Para vendedores, reuniones y equipos remotos."
        },
        "build_develop": {
            "label": "Construir y desarrollar",
            "shortLabel": "Desarrollar",
            "description": "Para desarrolladores, ingenieros y profesionales técnicos."
        },
        "game_play": {
            "label": "Juego y juego",
            "shortLabel": "Juego de azar",
            "description": "Para jugadores, streamers y controles multimedia."
        },
        "learn_teach": {
            "label": "Aprender y enseñar",
            "shortLabel": "Aprendiendo",
            "description": "Para educadores, estudiantes e instrucción."
        },
        "manage_organize": {
            "label": "Administrar y organizar",
            "shortLabel": "Organizando",
            "description": "Para gerentes de proyectos, coordinadores y organizadores."
        },
        "adapt_access": {
            "label": "Adaptación y acceso",
            "shortLabel": "Accesibilidad",
            "description": "Para controles adaptativos y necesidades de accesibilidad personalizadas."
        },
        "everything": {
            "label": "Un poco de todo",
            "shortLabel": "Todo",
            "description": "Para usuarios de computadoras en general y que realizan múltiples tareas a la vez."
        },
        "filter": "Filtrar por tipo de interés"
    },
    "capabilities": {
        "title": "Mis principales capacidades de IA",
        "description": "Combino IA avanzada con potentes métodos de entrada para ofrecerte un control total sobre tus aplicaciones y dispositivos. Estas son algunas de mis funciones.",
        "voice_controls": {
            "title": "Controles de voz",
            "description": "Entiendo comandos de lenguaje natural para que puedas controlar cualquier aplicación con tu voz.",
            "longDescription": "Te dejo hablar con naturalidad y aun así lograr tus objetivos. Ya sea que quieras abrir aplicaciones, navegar por los menús o iniciar flujos de trabajo, traduzco el inglés sencillo a acciones fiables y sin intervención manual."
        },
        "smart_dictation": {
            "title": "Dictado inteligente",
            "description": "Convierto tu discurso en texto con conocimiento del contexto y formato.",
            "longDescription": "Escucho atentamente y capto tus palabras con precisión. Agrego la puntuación, corrijo las mayúsculas y aplico formato contextual para que tu texto luzca impecable sin esfuerzo adicional."
        },
        "ai_text_generation": {
            "title": "Generación de texto con IA",
            "description": "Puedo crear correos electrónicos, documentos, códigos y contenido creativo sobre la marcha.",
            "longDescription": "Te ayudo a redactar, resumir o ampliar cualquier contenido directamente en tus aplicaciones. Desde correos electrónicos y notas hasta fragmentos de código y documentos, me aseguro de que nunca empieces desde cero."
        },
        "head_face_controls": {
            "title": "Controles de cabeza y cara",
            "description": "Te dejo provocar acciones con movimientos de cabeza y cara.",
            "longDescription": "Traduzco tus movimientos y expresiones naturales de cabeza en información precisa. Puedes enviar un correo electrónico con una sonrisa, pasar de página con un gesto de la cabeza o hacer clic levantando las cejas."
        },
        "natural_language_voice_clicking": {
            "title": "Clics de voz en lenguaje natural",
            "description": "Te dejo decir lo que ves para hacer clic en botones, enlaces y menús en la pantalla.",
            "longDescription": "Cuando dices el nombre de algo en tu pantalla, lo encuentro e interactúo con él por ti. Sin comandos memorizados: solo describe lo que quieres y yo me encargo de hacer clic."
        },
        "keyboard_mouse_emulation": {
            "title": "Emulación de teclado y ratón",
            "description": "Emulo teclas, clics y desplazamiento para que puedas controlar aplicaciones sin hardware.",
            "longDescription": "Envío pulsaciones de teclas, movimientos del ratón, clics y eventos de desplazamiento donde los necesites. Combíname con controles de voz o de cabeza para reemplazar o mejorar por completo los dispositivos de entrada tradicionales."
        },
        "profiles_personalization": {
            "title": "Personalización",
            "description": "Recuerdo tus preferencias y me adapto con los controles de aplicaciones guardadas.",
            "longDescription": "Monitoreo tus aplicaciones, comandos y preferencias favoritas. Cambia entre los controles de las aplicaciones de forma automática o manual, y siempre te mostraré los controles adecuados para lo que estés haciendo."
        },
        "cross_device_connectivity": {
            "title": "Conectividad entre dispositivos",
            "description": "Te permito usar tu teléfono para iniciar una automatización de forma remota.",
            "longDescription": "Conecto tu dispositivo móvil a tu escritorio para que puedas ejecutar comandos, dictar o navegar fácilmente. Perfecto para presentaciones, sesiones remotas o uso ocasional."
        },
        "quick_action_buttons": {
            "title": "Botones de acción rápida",
            "description": "Te doy botones compatibles con aplicaciones para acciones rápidas.",
            "longDescription": "Muestro botones contextuales que se adaptan a tu app. Ya sea para unirte a una reunión, enviar un mensaje o crear un correo electrónico, puedo realizar tareas complejas con solo un clic."
        },
        "ai_app_awareness": {
            "title": "Conciencia de las aplicaciones de IA",
            "description": "Ajusto mis controles en función de la aplicación que estés usando.",
            "longDescription": "Presto atención a lo que está activo en tu pantalla para ofrecerte los controles adecuados en el momento oportuno. Sin desorden ni conjeturas: solo lo que necesitas, cuando lo necesitas. Todo en tu dispositivo y sin enviar datos a la nube."
        },
        "ai_rewrite": {
            "title": "Reescritura de IA",
            "description": "Puedo reescribir su texto para mejorar el tono, actualizar el formato o ampliar los detalles.",
            "longDescription": "Edito textos justo donde trabajas. Puedo hacerlos más accesibles, más formales, más cortos, más largos o más detallados: lo que necesites para transmitir mejor tu mensaje."
        },
        "ai_translation": {
            "title": "Traducción de IA",
            "description": "Puedo traducir entre idiomas o incluso lenguajes de programación.",
            "longDescription": "Te permito convertir texto a otro idioma hablado o código a otro lenguaje de programación. Trabajo desde el sitio, así que no tienes que salir de la aplicación que estás usando."
        },
        "head_mouse": {
            "title": "Cabeza de ratón",
            "description": "Te dejo mover el cursor del mouse con movimientos de la cabeza.",
            "longDescription": "Convierto con fluidez el movimiento de tu cabeza en movimiento del cursor. Con funciones como deslizamiento y ajuste de sensibilidad, te ofrezco un control preciso, cómodo y manos libres."
        },
        "head_joystick": {
            "title": "Joystick de cabeza",
            "description": "Te dejo usar tu cabeza como joystick para juegos o aplicaciones.",
            "longDescription": "Mapeo los movimientos de tu cabeza en los ejes del joystick para que puedas jugar o controlar software creativo sin necesidad de hardware. Te mueves con naturalidad y yo lo traduzco a una señal analógica."
        },
        "mcp_agent": {
            "title": "Agente MCP",
            "description": "Puedo conectarme con agentes de IA externos a través del Protocolo de Contexto de Modelo (MCP).",
            "longDescription": "Domino el Protocolo de Contexto de Modelo, lo que me permite trabajar con otros agentes y herramientas de IA. Esto significa que puedo coordinar tareas, intercambiar contexto y ampliar mis capacidades con sistemas externos especializados, todo ello mientras te mantengo al mando."
        },
        "byo_ai_integration": {
            "title": "Trae tu propia IA",
            "description": "Te permito mejorar mi IA existente con tus propios modelos o servicios de IA para usar conmigo.",
            "longDescription": "Si ya cuenta con un servicio, modelo o proveedor de IA de confianza, puedo integrarlo en mi flujo de trabajo. Le doy la flexibilidad de elegir el motor que impulsa la generación, reescritura o traducción, ya sea en la nube, local o personalizado. Si no tiene conexión o el servicio no está disponible, puedo recurrir a mis funciones integradas."
        },
        "workflows": {
            "title": "Flujos de trabajo",
            "description": "Te ayudo a encadenar acciones en flujos de trabajo repetibles.",
            "longDescription": "Te permito diseñar y ejecutar procesos de varios pasos que conectan diferentes entradas, comandos y salidas. Con los flujos de trabajo, puedes automatizar tareas rutinarias o crear interacciones complejas, activadas por tu voz o gestos, para que yo me encargue del trabajo pesado."
        },
        "showMore": "Mostrar más",
        "showLess": "Mostrar menos",
        "background_creation": {
            "title": "Creación de fondos",
            "description": "Yo creo y edito el contenido en segundo plano mientras tú trabajas.",
            "longDescription": "Creo y edito el contenido en segundo plano mientras usted se concentra en su trabajo. Cuando lo necesite, el contenido estará listo en su sistema de archivos sin interrumpir su flujo de trabajo ni tener que copiarlo."
        },
        "ai_summary": {
            "title": "Resumen de IA",
            "description": "Extrae información valiosa de textos extensos y crea resúmenes breves o ideas clave."
        }
    },
    "listing": {
        "title": "Casos de uso",
        "titleLong": "Explora cómo puedo ayudarte",
        "recommended": "Recomendado para ti",
        "exploreMore": "Explorar más casos de uso",
        "description": "Descubre todo lo que puedo hacer para optimizar tu flujo de trabajo. Desde mejoras de productividad hasta asistencia creativa, encuentra los casos de uso perfectos, adaptados a tus necesidades.",
        "all": "Todo",
        "search": "Buscar casos de uso, aplicaciones o capacidades...",
        "noResults": "No se encontraron resultados. Intenta ajustar tu búsqueda o filtros.",
        "emptyAction": "Ver más en línea"
    },
    "examples": {
        "universalAppControl": {
            "title": "Control universal de aplicaciones",
            "description": "Controle cualquier aplicación en su computadora con comandos de voz y automatización inteligente",
            "descriptionLong": "Controla cualquier aplicación con potentes comandos de voz y automatización inteligente. Nuestro sistema Universal App Control aprende cómo trabajas y se adapta a tus necesidades, simplificando las tareas complejas e instantáneamente las acciones rutinarias. Desde la gestión de tu suite de productividad hasta el control de aplicaciones multimedia y de juegos, esta función funciona en todo tu entorno digital."
        },
        "documentSummary": {
            "title": "Agente de escritorio de IA privado que lee tus documentos, escribe el resumen y lo envía a tu equipo.",
            "description": "Utilice un agente de escritorio privado para leer documentos, redactar resúmenes y compartirlos con su equipo sin necesidad de usar las manos.",
            "descriptionLong": "Dirige tu agente de IA hacia un documento y deja que lo lea, lo resuma y lo envíe por ti. Mantén todo funcionando localmente y de forma privada mientras trabajas sin mover un dedo."
        },
        "editingVideos": {
            "title": "Edición de voz en CapCut: navega por las líneas de tiempo, corta clips y mantente en la historia.",
            "description": "Edita vídeos mediante comandos de voz y dictado, para que puedas cortar y organizar clips sin usar las manos.",
            "descriptionLong": "Navega por la línea de tiempo, recorta y divide clips, y da forma a tu edición usando solo tu voz. Mantente concentrado en la historia sin tener que navegar por menús ni usar el ratón."
        },
        "figma": {
            "description": "Edita imágenes y diseños mediante comandos de voz y dictado inteligente para realizar iteraciones más rápidas.",
            "descriptionLong": "Da vida a tus ideas visuales con la edición de imágenes controlada por voz. Navega más rápido y perfecciona tus diseños sin tener que navegar por menús complejos.",
            "title": "Comandos de voz para Figma y Canva: controla capas, cambia de herramienta y escribe y copia sin usar las manos."
        },
        "excelAnalysis": {
            "title": "Trabaje más rápido y analice en Excel con la automatización de IA privada y local.",
            "description": "Analice hojas de cálculo y detecte tendencias utilizando automatización de IA privada y local, sin necesidad de intervención manual.",
            "descriptionLong": "Analice las tendencias en una carpeta o documento, formule preguntas sobre los informes financieros y elabore un resumen final. Deje que la IA local se encargue del análisis, manteniendo sus datos privados en su propio equipo."
        },
        "emailAutomation": {
            "title": "¡Automatiza tu correo electrónico: flujos de trabajo de IA locales que leen tu bandeja de entrada, redactan respuestas y mucho más!",
            "description": "Lee tu bandeja de entrada, redacta respuestas y crea plantillas utilizando flujos de trabajo de IA locales y dictado.",
            "descriptionLong": "Redacta un correo electrónico resumiendo un artículo y destacando los detalles técnicos clave, o crea plantillas reutilizables para gestionar tu bandeja de entrada más rápidamente. Deja que la IA y el dictado locales se encarguen de la lectura y la escritura, manteniendo toda la privacidad."
        },
        "powerpointBuilder": {
            "description": "Convierte notas, documentos y hojas de cálculo en una presentación de PowerPoint terminada utilizando flujos de trabajo de IA, sin necesidad de intervención manual.",
            "descriptionLong": "Analiza un documento de Excel para identificar las pérdidas clave y deja que la IA transforme tus notas y datos en una presentación impecable. Crea presentaciones más rápido sin tener que navegar por menús ni empezar desde cero.",
            "title": "Flujos de trabajo de IA que convierten tus notas y documentos en una presentación de PowerPoint terminada | Creador de PowerPoint con IA"
        },
        "socialDictation": {
            "description": "Publica y responde en LinkedIn, Slack y Discord usando la función de voz a texto, sin necesidad de escribir.",
            "descriptionLong": "Redacta publicaciones, responde mensajes y mantente activo en LinkedIn, Slack y Discord usando solo tu voz. Mantén la conversación sin necesidad de usar el teclado.",
            "title": "Conversión de voz a texto para LinkedIn, Slack y Discord | Publica y responde sin escribir"
        },
        "developerTools": {
            "title": "Controles por voz + Automatizaciones de IA para desarrolladores | Escribe comentarios, documentación y mensajes de confirmación",
            "description": "Escribe comentarios, documentos y mensajes de confirmación mediante comandos de voz y automatizaciones de IA, sin usar las manos.",
            "descriptionLong": "Pregunta cómo organizar mejor el código en la carpeta de un proyecto y luego dicta comentarios, documentación y mensajes de confirmación sin necesidad de escribir. Mantén la concentración mientras los comandos de voz y la automatización con IA se encargan de las tareas tediosas."
        },
        "terminalAgent": {
            "title": "Agente de escritorio con IA | Ejecuta compilaciones y pruebas de terminal en segundo plano mientras sigues programando.",
            "description": "Ejecuta compilaciones, pruebas y depuración en segundo plano con un agente de escritorio de IA mientras sigues programando.",
            "descriptionLong": "Haz que tu agente revise la carpeta del proyecto, lo compile, confirme que se compila correctamente y ejecute las pruebas. Si algo falla, buscará la causa en el historial de Git y sugerirá una solución, todo mientras tú te concentras en tu trabajo."
        },
        "gamingFPS": {
            "description": "Apunta, dispara, recarga y cambia de arma en juegos FPS como Valorant usando controles de voz, sin necesidad de usar las manos.",
            "descriptionLong": "Da órdenes para disparar, recargar y cambiar de arma mientras juegas a títulos FPS como Valorant. Añade control por voz a tu configuración y mantén la acción sin depender de cada tecla y botón.",
            "title": "Controles por voz para FPS, Valorant y más | Apunta, dispara, recarga y cambia de arma sin usar las manos"
        },
        "gamingRPG": {
            "title": "Personaliza los controles de juegos de rol para Minecraft | Controles adaptativos para videojuegos",
            "description": "Personaliza y adapta los controles de Minecraft y otros juegos de rol para que se ajusten a tu estilo de juego.",
            "descriptionLong": "Configura controles adaptativos para Minecraft y otros juegos de rol, asignando las acciones según tus necesidades. Crea un esquema de control que se ajuste a tu forma de jugar, en lugar de forzar tus manos a adaptarse al juego."
        },
        "educationTools": {
            "description": "Convierte notas y artículos en herramientas de estudio y materiales didácticos utilizando inteligencia artificial integrada en el dispositivo, sin necesidad de usar las manos.",
            "descriptionLong": "Toma un artículo y crea un documento de Word con preguntas de reflexión adaptadas al nivel de cada estudiante para apoyar una actividad de escritura creativa. Deja que la IA integrada en el dispositivo transforme tu material original en recursos didácticos listos para usar, manteniendo toda la privacidad.",
            "title": "Transforma apuntes y artículos de clase en herramientas de estudio creativas o materiales didácticos mediante IA en el dispositivo."
        },
        "meetingNotes": {
            "title": "Automatizaciones de IA que convierten las notas de reuniones en archivos más pequeños.",
            "description": "Convierta las notas de las reuniones en archivos organizados y prácticos mediante automatizaciones de IA, sin necesidad de intervención manual.",
            "descriptionLong": "Revisa las notas de tus reuniones para identificar qué tareas quedan pendientes, quién es el responsable y dónde hay deficiencias. Deja que la IA genere un resumen de estas tareas en archivos separados y los organice en una carpeta para que puedas revisarlos todos más tarde."
        },
        "fileManagement": {
            "description": "Organiza tus descargas, encuentra archivos y limpia tu PC con un agente de escritorio con IA integrado en tu dispositivo, sin necesidad de usar las manos.",
            "descriptionLong": "Pídele a tu agente que copie los archivos descargados en el directorio de documentación del producto, o que busque archivos y organice tu PC. Mantén tu equipo organizado con inteligencia artificial integrada que protege la privacidad de tus datos.",
            "title": "Agente de escritorio con IA en el dispositivo | Organiza tus descargas, encuentra archivos y limpia tu PC"
        },
        "dictationWriting": {
            "title": "Escritura manos libres y creación de documentos: dictado por voz, generación por IA y reescritura en cualquier aplicación.",
            "description": "Escribe, genera y reescribe documentos sin usar las manos mediante dictado por voz e inteligencia artificial en cualquier aplicación.",
            "descriptionLong": "Dicta texto, genera contenido nuevo y reescribe lo que has escrito en cualquier aplicación usando solo tu voz. Crea documentos de principio a fin sin tocar el teclado."
        },
        "headMouseControl": {
            "title": "Control de ordenador manos libres con ratón de cabeza, función de voz para pulsar | Controles informáticos adaptativos",
            "description": "Controla tu ordenador sin usar las manos gracias al seguimiento de la cabeza y a los controles adaptativos Talk to Tap.",
            "descriptionLong": "Mueve el cursor con el seguimiento de la cabeza y haz clic con la función Talk to Tap para navegar por tu ordenador sin usar las manos. Configura controles adaptativos que te permitan trabajar de la forma que mejor se ajuste a ti."
        },
        "documentTranslation": {
            "title": "Traducción de documentos con IA para cualquier persona que trabaje con varios idiomas: español, árabe, portugués y más.",
            "description": "Traduce documentos a través de idiomas como español, árabe y portugués usando inteligencia artificial, sin necesidad de usar las manos.",
            "descriptionLong": "Traduce tus documentos al español, árabe, portugués y otros idiomas con la IA integrada en tu dispositivo. Trabaja con confianza en diferentes idiomas sin cambiar de herramienta ni copiar texto entre aplicaciones."
        },
        "websiteRedesign": {
            "description": "Investiga a la competencia y obtén sugerencias para rediseñar tu sitio web usando IA, sin necesidad de intervención manual.",
            "descriptionLong": "Dirige la IA al sitio web de SafeDrive Auto Insurance y luego haz que investigue los sitios de la competencia para detectar las diferencias. Obtén sugerencias concretas para modernizar un sitio obsoleto basadas en estudios de mercado reales.",
            "title": "Investigación web privada con IA + automatizaciones | Navegar, analizar y crear HTML"
        },
        "dataPrivacyResearch": {
            "description": "Investigue las últimas leyes de privacidad de datos y convierta los hallazgos en acciones de seguimiento para el cumplimiento normativo, sin necesidad de intervención manual.",
            "descriptionLong": "Investiga las leyes de privacidad de datos más recientes de 2026 y sus diferencias con las de 2025, y luego identifica las medidas que las empresas deben implementar. Utiliza IA para redactar un correo electrónico de seguimiento con ejemplos que te ayuden a cumplir con la normativa.",
            "title": "Navega, analiza y resume sin que tus datos salgan de tu dispositivo | Investigación web privada con IA"
        }
    },
    "control": {
        "title": "Control.",
        "subtitle": "Tu software. Tus datos de entrada. Tus reglas.",
        "description": "Comandos de voz, atajos de teclado y botones de acción rápida: funcionan en todas las aplicaciones de tu dispositivo. No necesitas ratón. No necesitas programar nada. No necesitas configurar nada para las cientos de aplicaciones que ya usas.",
        "titleAlt": "Control"
    },
    "create": {
        "title": "Crear.",
        "subtitle": "Tus palabras. Tus borradores. Tu máquina.",
        "description": "Redacta, reescribe, reformatea y traduce, directamente en la aplicación en la que trabajas. Sin la nube. Sin copiar y pegar en otra herramienta. Sin borradores que entrenen el modelo de otra persona.",
        "titleAlt": "Crear"
    },
    "automate": {
        "title": "Automatizar.",
        "subtitle": "Una frase. Cada paso. Hecho.",
        "description": "Describe una tarea en lenguaje sencillo y Cephable la ejecuta. En todas tus aplicaciones, archivos e incluso en la línea de comandos. Se ejecuta mientras haces otras cosas y nada sale de tu máquina.",
        "titleAlt": "Automatizar"
    },
    "upgrade": {
        "subtitle": {
            "trial": "Durante los próximos {{days}} días, mis funciones de IA estarán desbloqueadas: Crear y Automatizar, ambas funcionando en un mismo dispositivo. Actívalas cuando quieras.",
            "orgGeneric": "Tu organización ha desbloqueado mis funciones de IA: Crear y Automatizar, ambas funcionando en un único dispositivo. Actívalas cuando quieras.",
            "org": "Te hemos añadido a la organización {{organization}}, lo que desbloquea mis funciones de IA: Crear y Automatizar, ambas funcionando en un mismo dispositivo. Actívalas cuando quieras."
        },
        "badge": {
            "trial": "El juicio termina en",
            "trialDays_one": "{{count}} día",
            "trialDays_other": "{{count}} días",
            "org": "Desbloqueado por",
            "orgGeneric": "Licencia de organización"
        },
        "setup": {
            "eyebrow": "Configura tus funciones Pro",
            "title": "Elige qué encender",
            "description": "Puedes modificar cualquiera de estas opciones más adelante en Ajustes. Todo se ejecuta en el dispositivo: tus palabras y archivos permanecen contigo."
        },
        "enable": {
            "title": "Habilitar funciones de IA",
            "description": "Un solo interruptor activa tanto Crear como Automatizar. Ambas funcionan con el modelo compartido en el dispositivo; no se requiere una configuración independiente para cada una.",
            "model": {
                "label": "Modelo de IA en el dispositivo",
                "tag": "Motor compartido",
                "description": "Permite tanto la creación como la automatización. Los modelos más grandes ofrecen mejores resultados, pero consumen más recursos; se descarga y ejecuta completamente en este dispositivo."
            }
        },
        "create": {
            "title": "Crear",
            "description": "Generación inteligente de texto y dictado. Redactaré correos electrónicos, documentos, código y contenido creativo, y convertiré tu voz en texto formateado para cualquier aplicación.",
            "locked": "Habilita las funciones de IA que aparecen arriba y Create estará listo para usar."
        },
        "automate": {
            "title": "Automatizar",
            "description": "Flujos de trabajo de IA. Describe una tarea en una sola frase y yo planificaré y llevaré a cabo cada paso: leeré, escribiré y ejecutaré comandos en tu nombre.",
            "locked": "Habilita las funciones de IA mencionadas anteriormente y Automate estará listo para usar."
        },
        "status": {
            "on": "En",
            "off": "No funciona"
        },
        "footer": "Todo se ejecuta en el dispositivo. Nada de lo que crees o automatices sale de tu máquina.",
        "cta": {
            "eyebrow": "Puedes activar la IA en cualquier momento.",
            "title": "Veamos cómo funciona en tus aplicaciones.",
            "action": "Mírame en acción",
            "back": "Atrás"
        },
        "pill": "{{licencia}} Desbloqueado",
        "title": "Se te ha actualizado a {{license}}."
    }
}
